import { render } from "./BatterySectionSkeleton.vue?vue&type=template&id=3ff910c7"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__